import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, onMounted, computed } from "vue";

import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import TopSettingsPanel from "@/entities/settings/panels/TopSettingsPanel.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import PermissionsTable from "@/entities/settings/PermissionsTable.vue";
import SettingsFilterForm from "@/entities/settings/forms/SettingsFilterForm.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";

import {
  useOrganizationsStore,
  OrganizationFromServer,
} from "@/store/dictionaries/organizations";
import { useAuthStore } from "@/store/auth/login";

import {
  excludeDepartmentsAndRoles,
  filterByStr,
} from "@/services/permissions/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsPage',
  setup(__props) {

const organizationsStore = useOrganizationsStore();
const authStore = useAuthStore();
const isLoading = ref(false);
const isFilterEnabled = ref(false);
const isFilterSetted = ref(false);

const choosenOrganization = ref<OrganizationFromServer | null>(null);
const choosenOrganizationWithoutFilter = ref<OrganizationFromServer | null>(
  null
);
const baseOrg = ref(0);

onMounted(() => {
  if (isDenied.value) return;
  authStore.getOrganizationByUserTenant().then((orgValue: any) => {
    if (orgValue) {
      setFilter(
        {
          organization: orgValue.id,
          department: [],
          role: [],
        },
        true
      );
      baseOrg.value = orgValue.id;
    }
    isLoading.value = false;
  });
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions([
    "settings:read",
    "settings:edit",
    "system:read",
    "system:edit",
  ]);
});

const loadData = (orgId: number) => {
  isLoading.value = true;

  return organizationsStore
    .getOrganizationBase(orgId)
    .then((organization) => {
      choosenOrganization.value = organization;
      choosenOrganizationWithoutFilter.value = JSON.parse(
        JSON.stringify(organization)
      );
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const setCommonFilter = (filter: string) => {
  if (filter && choosenOrganization.value) {
    choosenOrganization.value = filterByStr(choosenOrganization.value, filter);
  } else {
    choosenOrganization.value = JSON.parse(
      JSON.stringify(choosenOrganizationWithoutFilter.value)
    );
  }
};

const setLoading = (loading: boolean) => {
  isLoading.value = loading;
};

const setFilter = (filter: any, isSetted: boolean) => {
  loadData(filter.organization).then(() => {
    if (choosenOrganization.value)
      choosenOrganization.value = excludeDepartmentsAndRoles(
        choosenOrganization.value,
        filter.department,
        filter.role
      );
    choosenOrganizationWithoutFilter.value = JSON.parse(
      JSON.stringify(choosenOrganization.value)
    );

    isFilterSetted.value = isSetted;
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsWithTableLayout, null, {
    body: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(SettingsFilterForm, {
            isFilterEnabled: isFilterEnabled.value,
            onToggleFilter: _cache[0] || (_cache[0] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value)),
            onSetFilter: setFilter,
            "base-organization": baseOrg.value
          }, null, 8, ["isFilterEnabled", "base-organization"]),
          _createVNode(TopSettingsPanel, {
            isFilterEnabled: isFilterEnabled.value,
            isFilterSetted: isFilterSetted.value,
            onSetCommonFilter: setCommonFilter,
            onToggleFilter: _cache[1] || (_cache[1] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value)),
            "search-placeholder": "Поиск"
          }, null, 8, ["isFilterEnabled", "isFilterSetted"]),
          _createElementVNode("div", {
            id: "table-container",
            class: _normalizeClass(["table-container flex flex-col", [
            choosenOrganization.value && choosenOrganization.value.departments.length == 0
              ? 'empty'
              : 'filled',
          ]])
          }, [
            _createVNode(PermissionsTable, {
              organization: choosenOrganization.value,
              isLoading: isLoading.value,
              onSetLoading: setLoading
            }, null, 8, ["organization", "isLoading"]),
            (
              choosenOrganization.value &&
              choosenOrganization.value.departments.length == 0 &&
              !isLoading.value
            )
              ? (_openBlock(), _createBlock(EmptyTableMessage, { key: 0 }, {
                  text: _withCtx(() => [
                    _createTextVNode(" Создайте первую рекламную кампанию. "),
                    _hoisted_1,
                    _createTextVNode(" Для этого кликните на кнопку \"Создать РК\". ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})